import React, { useEffect, useRef, useState } from 'react';
import { Badge, Button, message } from 'antd';
import { CustomerServiceOutlined } from '@ant-design/icons';

const SupportButton = ({ children = '联系客服', ...props }) => {
  const [opening, setOpening] = useState(false);
  const [unread, setUnread] = useState(window.beeSupportUnread || 0);
  const timer = useRef(null);
  useEffect(() => {
    const onUnread = () => setUnread(window.beeSupportUnread || 0);
    const onOpened = () => {
      clearTimeout(timer.current);
      setOpening(false);
    };
    window.addEventListener('bee-support-unread', onUnread);
    window.addEventListener('bee-support-open', onOpened);
    return () => {
      clearTimeout(timer.current);
      window.removeEventListener('bee-support-unread', onUnread);
      window.removeEventListener('bee-support-open', onOpened);
    };
  }, []);
  const openChat = () => {
    if (opening || window.beeSupportOpen) return;
    if (!window.ssq?.push) {
      message.warning('客服暂时无法连接，请稍后重试或联系业务对接人。');
      return;
    }
    setOpening(true);
    timer.current = setTimeout(() => {
      setOpening(false);
      message.warning('客服连接较慢，请稍后重试或联系业务对接人。');
    }, 10000);
    try {
      // The deployed SDK cannot clone a command callback; use its onOpenChat event.
      window.ssq.push('chatOpen');
    } catch {
      clearTimeout(timer.current);
      setOpening(false);
      message.warning('客服暂时无法连接，请稍后重试或联系业务对接人。');
    }
  };
  return (
    <Button
      type="text"
      icon={
        <Badge dot={unread > 0}>
          <CustomerServiceOutlined />
        </Badge>
      }
      aria-label={unread ? `联系客服，${unread} 条未读消息` : '联系客服'}
      {...props}
      onClick={openChat}
      loading={opening}
    >
      {children}
    </Button>
  );
};
export default SupportButton;
